<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"> </app-loading-state>

<ng-template #loadedContent>
	<div class="notification-settings-container">
		<div class="content">
			<form [formGroup]="notificationForm">
				<div class="form-container">
					<app-alert
						[dismissible]="true"
						content="This is where you can update your notification preferences, you can choose to globally enable notifications as well as select the type of notifications you would like to receive."
					></app-alert>
					<h4 class="text-primary">Notification Preferences</h4>

					<div class="form-row">
						<div class="text-primary">Notifications Enabled</div>
						<app-switch-control name="notificationsEnabled" [formGroup]="notificationForm"></app-switch-control>
					</div>

					<div class="text-indent">
						<div class="form-row">
							<div class="text-primary">New Leads</div>
							<app-switch-control name="newLeads" [formGroup]="notificationForm"></app-switch-control>
						</div>

						<div class="form-row">
							<div class="text-primary">Assessment Status Change</div>
							<app-switch-control name="assessmentStatus" [formGroup]="notificationForm"></app-switch-control>
						</div>

						<div class="form-row">
							<div class="text-primary">Assigned Assessment</div>
							<app-switch-control name="assignedLeadAssessment" [formGroup]="notificationForm"></app-switch-control>
						</div>
					</div>
				</div>
			</form>

			<div class="device-container">
				<h4 class="text-primary">Your Devices</h4>

				<ng-container *ngIf="userDevices.length; else noDevices">
					<ng-container *ngFor="let device of userDevices; let i = index">
						<app-user-device-card
							[device]="device"
							[currentDeviceId]="currentDeviceId"
							(remove)="handleRemoveDevice($event)"
						></app-user-device-card>
					</ng-container>
				</ng-container>
				<ng-template #noDevices>
					<em>You currently have no registered devices to receive notifications.</em>
				</ng-template>
			</div>
		</div>
		<div class="footer">
			<button
				type="button"
				class="btn btn-sm btn-outline-danger btn-width"
				(click)="handleCancel()"
				[disabled]="notificationForm.pristine"
			>
				Cancel
			</button>
			<button
				type="button"
				class="btn btn-sm btn-primary btn-width"
				(click)="handleSave()"
				[disabled]="notificationForm.invalid || notificationForm.pristine"
			>
				<ng-container *ngIf="isSaving; else saveText">
					<div class="spinner-border spinner-border-sm" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</ng-container>
				<ng-template #saveText> Save </ng-template>
			</button>
		</div>
	</div>
</ng-template>
